/* @flow */

import { NOMES_ETAPAS } from '../constants';
import { type EtapasId } from '../types';

const getTitulo = (etapasId: EtapasId) => `Alterar para ${NOMES_ETAPAS[etapasId].toLowerCase()}?`;

export default getTitulo;
